<template>
  <div
    class="card"
    :class="{ 'card-outlined': outlined }"
    :style="{ height }"
    @contextmenu.prevent="handleContextMenu"
  >
    <div v-if="showTags" class="card-tags overlay-line">
      <v-chip
        v-for="tag in tags"
        color="var(--v-grey-lighten-2)"
        label
        outlined
        text-color="white"
        :key="tag"
      >
        {{ tag }}
      </v-chip>
    </div>
    <img
      v-show="!loading"
      alt="Car image"
      class="card-img"
      :src="src"
      @dblclick="handleViewImage"
      @load="loadImage"
    />
    <div
      v-if="loading"
      class="thumbnail"
      @dblclick="handleViewImage"
    />
    <div class="overlay-line options-bottom">
      <div class="options-info">
        <div>
          <div>
            <v-btn
              v-if="isFeedback"
              class="btn-feedback btn-info"
              icon
              @click="handleFeedback"
            >
              <v-icon>$vuetify.icons.report</v-icon>
            </v-btn>
            <v-btn
              v-if="isComment"
              class="btn-comment btn-info"
              icon
              @click="handleComment"
            >
              <v-icon>$vuetify.icons.message</v-icon>
            </v-btn>
          </div>
          <div v-if="time" class="option-fill options-time">{{ time }}</div>
        </div>
        <span v-if="showNumbers && carNumber" class="option-fill options-number">{{ carNumber }}</span>
      </div>
      <div v-if="showActions" class="options-actions">
        <v-tooltip
          v-for="button in buttons"
          bottom
          open-delay="1000"
          :key="button.title"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="btn-action"
              icon
              v-bind="attrs"
              v-on="on"
              @click="button.action"
            >
              <v-icon class="action-icon" size="20">{{ button.icon }}</v-icon>
            </v-btn>
          </template>
          <span>{{ button.title }}</span>
        </v-tooltip>
        <v-menu
          nudge-top="8"
          offset-y
          top
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="btn-action"
              icon
              v-bind="attrs"
              v-on="on"
            >
              <v-icon class="action-icon" size="20">$vuetify.icons.more</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item
              v-for="item in menuItems"
              class="btn-action"
              tag="button"
              :key="item.title"
              @click="item.action"
            >
              <v-list-item-title>
                <v-icon class="action-icon" size="20">{{ item.icon }}</v-icon>
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RaceImg',
  props: {
    buttons: {
      type: Array,
    },
    carNumber: {
      type: String,
    },
    height: {
      type: [Number, String]
    },
    isComment: {
      type: Boolean,
      default: false,
    },
    isFeedback: {
      type: Boolean,
      default: false,
    },
    menuItems: {
      type: Array,
    },
    outlined: {
      type: Boolean,
      default: false,
    },
    showActions: {
      type: Boolean,
      default: true,
    },
    showNumbers: {
      type: Boolean,
      default: true,
    },
    showTags: {
      type: Boolean,
      default: true,
    },
    src: {
      type: String,
    },
    tags: {
      type: Array,
    },
    time: {
      type: String,
    },
  },
  data() {
    return {
      loading: true,
    }
  },
  methods: {
    handleComment() {
      this.$emit('comment')
    },
    handleContextMenu(e) {
      this.$emit('handleContextMenu', e)
    },
    handleFeedback() {
      this.$emit('feedback')
    },
    handleViewImage() {
      this.$emit('viewImage')
    },
    loadImage() {
      this.loading = false
    },
  },
}
</script>

<style lang="scss" scoped>
.card {
  position: relative;
  background-color: white;
  border-radius: 6px;
  color: white;
  line-height: 1;
  overflow: hidden;
}

.card-outlined {
  filter: drop-shadow(0px 5px 5px rgba(var(--v-primary-base-rgb), 0.1))
          drop-shadow(0px 9px 10px rgba(var(--v-primary-base-rgb), 0.07))
          drop-shadow(0px 5px 14px rgba(var(--v-primary-base-rgb), 0.06));
  outline: 2px solid var(--v-primary-base);
  outline-offset: 2px;
}

.card-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.card-tags {
  top: 0;
  display: flex;
  justify-content: center;
  gap: 4px;
  padding: 4px 8px;
  background: rgba(0, 0, 0, 0.6);
}

.options-time {
  padding: 3px 14px;
  margin-top: 4px;
  font-size: 14px;
  font-weight: 500;
  line-height: 24px;
}

.options-bottom {
  bottom: 0;
}

.options-info {
  padding: 6px;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
}

.options-number {
  padding: 7px 15px;
  font-size: 24px;
}

.options-actions {
  display: flex;
  gap: 4px;
  padding: 4px;
  background: rgba(0, 0, 0, 0.6);
}

.option-fill {
  background: rgba(0, 0, 0, 0.6);
  border-radius: 6px;
  border: 1px solid rgba(255, 255, 255, 0.6);
  text-shadow: -1px 1px 0px black,
                1px 1px 0px black,
                1px -1px 0px black,
                -1px -1px 0px black;
}

.btn-info {
  width: 42px;
  height: 36px;
  border: 1px solid rgba(255, 255, 255, 0.6);
}

.btn-action {
  flex: 1;

  &:hover::before {
    opacity: 1;
    background: rgba(0, 0, 0, 0.6);
    border-radius: 6px;
  }
}

.overlay-line {
  position: absolute;
  left: 0;
  right: 0;
}

.thumbnail {
  height: 100%;
  width: 100%;
  background-image: url(/images/car_thumbnail.png);
  background-repeat: no-repeat;
  background-position: center;
}

::v-deep {
  .v-chip.v-chip--outlined.v-chip {
    background-color: rgba(0, 0, 0, 0.6)!important;
    line-height: inherit;
  }

  .v-list {
    display: flex;
    flex-direction: column;
    gap: 4px;
    padding: 4px;
    background: rgba(0, 0, 0, 0.6);
    backdrop-filter: blur(8px);
  }

  .v-list-item {
    min-height: 32px;
  }

  .action-icon {
    circle {
      fill: white;
    }

    path,
    rect {
      stroke: white;
      fill: none;
    }
  }

  .btn-feedback {
    background: var(--v-warning-base);
    margin-right: 4px;

    circle,
    path,
    rect {
      stroke: var(--v-warning-base);
      fill: white;
    }
  }

  .btn-comment {
    background: var(--v-primary-base);

    path {
      stroke: var(--v-primary-base);
      fill: white;
    }
  }
}
</style>
